import { http } from '@/shared/https';
import { ITemplateMgrService } from './templateMgr.types';

export class TemplateMgrService implements ITemplateMgrService {
    upload(payload: any) {
        return http.post(`api/Template`, payload, 'multipart/form-data')
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                }
            });
    }
    
    list() {
        return http.get(`api/Template/List`)
            .then((resp: any) => {
                if (resp.status >= 200 && resp.status < 300) {
                    return resp.data;
                }
            });
    }

    delete(id: number) {
        return http.delete(`api/Template/${id}`).then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            }
        });
    }
}